<template>
  <div>
    <van-nav-bar title="关于我们" left-arrow @click-left="$router.back()" />
    <div class="brand">
      <img v-if="logoUrl" class="logo" :src="logoUrl" alt="">
      <div v-else class="logo logo-fallback"><van-icon name="shop-o" /></div>
      <div class="name">{{ companyName || '会员中心' }}</div>
      <div v-if="version" class="version">版本 {{ version }}</div>
    </div>
    <div class="body">
      <div class="label">介绍</div>
      <div v-if="content" class="text">{{ content }}</div>
      <div v-else class="empty">暂未填写介绍</div>
    </div>
  </div>
</template>

<script>
import { getAbout } from '../api'
import { assetUrl } from '../utils/asset'

export default {
  data() {
    return { logo: '', companyName: '', version: '', content: '' }
  },
  computed: {
    logoUrl() {
      return assetUrl(this.logo)
    }
  },
  created() {
    getAbout().then(res => {
      const data = res.data || {}
      this.logo = data.logo || ''
      this.companyName = data.companyName || ''
      this.version = data.version || ''
      this.content = data.content || ''
    })
  }
}
</script>

<style scoped>
.brand { margin: 12px 12px 0; background: #fff; border-radius: 12px; padding: 28px 16px 22px; text-align: center; }
.logo { width: 72px; height: 72px; border-radius: 18px; object-fit: cover; display: block; margin: 0 auto; }
.logo-fallback { background: #e7f3ef; color: #1f6f5b; font-size: 32px; display: flex; align-items: center; justify-content: center; }
.name { margin-top: 12px; font-size: 18px; font-weight: 600; }
.version { margin-top: 6px; color: #888; font-size: 13px; }
.body { margin: 12px; background: #fff; border-radius: 12px; padding: 16px; }
.label { color: #888; font-size: 13px; margin-bottom: 8px; }
.text { white-space: pre-wrap; line-height: 1.7; }
.empty { color: #999; }
</style>
